module.exports = __webpack_public_path__ + "static/media/fire-extinguisher.a838725c.svg";